export default __webpack_public_path__ + "media/d5b9aa2a98045c6cc0d401023498593a64e6c3dde3cffb6911fdcfd65db2dbf1.svg";